import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import myImage from "../static/img/data.jpeg";
import pub_header from "../static/img/publications.jpg";
import "../static/css/publications.css";

const Publications = () => {
  const navigate = useNavigate();
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublications();
  }, []);

  const fetchPublications = async () => {
    try {
      const response = await fetch("https://backend.skpandco.in/publications");
      const data = await response.json();
      const formattedData = data.map((pub) => ({
        ...pub,
        imgSrc: pub.imgSrc || myImage,
        link: "/publication-detail",
      }));
      setPublications(formattedData);
    } catch (error) {
      console.error("Error fetching publications:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReadMore = (publication) => {
    navigate("/publication-detail", {
      state: {
        publication,
        allPublications: publications,
      },
    });
  };

  const truncateText = (text, wordLimit = 10) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  return (
    <>
      <div className="publications">
        <div className="pub-header">
          <div className="pub-header-txt"></div>
          <div className="pub-header-img">
            <img src={pub_header} alt="" />
          </div>
        </div>
        <div className="pub-header-text">
          <h1>Publications</h1>
          <p>
            Explore our collection of regulatory updates, newsletters, and
            industry insights to stay informed about the latest developments in
            the field.
          </p>
          <p>
            Our publications cover a wide range of topics including daily
            regulatory changes, industry analysis, market trends, and expert
            commentary. Whether you're a professional seeking to stay compliant
            or an enthusiast wanting to deepen your knowledge, our resources are
            designed to keep you well-informed.
          </p>
        </div>
        <div className="con">
          <h2>Our Publications</h2>
          {loading ? (
            <p>Loading publications...</p>
          ) : (
          <div className="con-grid">
            {publications.map((publication, index) => (
              <div key={index} className="con-item">
                <img
                  className="con-img"
                  src={publication.imgSrc}
                  alt={publication.title}
                />
                <div className="con-content">
                  <div className="con-txt-1">
                    <p>{publication.title}</p>
                  </div>
                  <div className="con-txt-2">
                    <p>{truncateText(publication.description)}</p>
                  </div>
                  <button
                    className="read-more-btn"
                    onClick={() => handleReadMore(publication)}
                  >
                    Read More
                  </button>
                </div>
              </div>
            ))}
          </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Publications;